"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * @author OPt
 * @author Adam Drda
 */


var ForecastCoordinatorUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastCoordinatorUpdateDTO, _DomainObject_1$Domai);

  function ForecastCoordinatorUpdateDTO(windowItemId, promoVolume, lastPromoVolumeUpdate) {
    var _this;

    _classCallCheck(this, ForecastCoordinatorUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorUpdateDTO).call(this));
    _this.windowItemId = windowItemId;
    _this.promoVolume = promoVolume;
    _this.lastPromoVolumeUpdate = lastPromoVolumeUpdate;
    return _this;
  }

  _createClass(ForecastCoordinatorUpdateDTO, [{
    key: "containsChanges",
    value: function containsChanges() {
      return !utils_1.Utils.isValueMissing(this.promoVolume);
    }
  }]);

  return ForecastCoordinatorUpdateDTO;
}(DomainObject_1.DomainObject);

exports.ForecastCoordinatorUpdateDTO = ForecastCoordinatorUpdateDTO;

ForecastCoordinatorUpdateDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastCoordinatorUpdateDTO.name);
  return {
    windowItemId: builder.id('windowItemId'),
    promoVolume: builder.opt(builder.bigNum('promoVolume')),
    lastPromoVolumeUpdate: builder.opt(builder.date('lastPromoVolumeUpdate', DateParser_1.DateParser.ISO_PATTERN))
  };
}();